<template>
  <v-container fluid>
    <v-card flat>
      <v-toolbar>
        <v-icon>call_made</v-icon>
        <v-toolbar-title class="font-weight-light">
          <v-row>
            <v-col>
              <div>&nbsp;Alta de Cargos</div>
            </v-col>
          </v-row>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.stop="hide(false)"><v-icon>close</v-icon></v-btn>
      </v-toolbar>

      <v-card-text>
        <v-container fluid>
          <v-row v-if="!selectedPersona" dense>
            <v-col>
              <span>Seleccione a una Persona</span>
            </v-col>
          </v-row>

          <v-row align="center" v-if="!selectedPersona">
            <v-col cols="12">
              <app-busqueda-personas
                :personaSeleccionada="setPersona"
              ></app-busqueda-personas>
            </v-col>
          </v-row>

          <v-row v-if="selectedPersona">
            <v-col>
              <span>Persona seleccionada</span>
            </v-col>
          </v-row>

          <v-row align="center" v-if="selectedPersona">
            <v-col cols="4">
              <v-text-field
                v-model="selectedPersona.cui"
                label="CUI(L/T) "
                key="cuil"
                :disabled="true"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="selectedPersona.nombreCompleto"
                label="Nombre"
                :disabled="true"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-btn color="warning" small text @click="limpiar"
                >Cancelar</v-btn
              >
            </v-col>
          </v-row>

          <v-row v-if="selectedPersona">
            <v-switch
              v-model="seAsociaACredito"
              label="El cargo se Asocia a un Crédito"
            ></v-switch>
          </v-row>

          <!-- lista de deudas de la persona -->
          <v-container fluid v-if="selectedPersona && seAsociaACredito">
            <v-card flat>
              <v-card-title>
                <span class="title">Deudas Actuales</span>
              </v-card-title>

              <v-row>
                <v-col>
                  <v-card flat>
                    <v-card-title>
                      <span v-if="!loadingDeudas">Créditos con Deuda</span>
                      <span v-if="loadingDeudas" class="green--text">
                        (Consultando Deudas de la Persona...
                        <v-progress-circular
                          indeterminate
                          size="24"
                          color="green"
                        ></v-progress-circular
                        >)</span
                      >
                    </v-card-title>
                    <v-divider></v-divider>

                    <!-- créditos con deuda -->
                    <v-container fluid v-if="listDeudas.length > 0">
                      <v-row class="body-2">
                        <v-col> Crédito </v-col>
                        <v-col> Deuda a la Fecha </v-col>
                      </v-row>

                      <v-divider></v-divider>

                      <template v-for="(item, index) in listDeudas">
                        <v-row :key="index">
                          <v-container fluid>
                            <v-row class="caption" no-gutters>
                              <v-col>
                                Nº {{ item.numero }}, de {{ item.origen }}
                              </v-col>
                              <v-col>
                                {{ item.deudaALaFecha }}
                              </v-col>
                            </v-row>
                            <v-row no-gutters>
                              <v-col>
                                <v-btn
                                  small
                                  text
                                  color="green"
                                  @click="
                                    creditoSeleccionadoId = item.id;
                                    creditoSeleccionadoNumero = item.numero;
                                    showDetalleCredito = true;
                                  "
                                >
                                  Aplicar Cargo a este Crédito
                                </v-btn>
                              </v-col>
                            </v-row>
                            <v-row v-if="isExpandedDetalleCredito(item)">
                              <v-col cols="12">
                                <v-container>
                                  <v-card outlined>
                                    <v-card-text>
                                      <v-row>
                                        <v-col>
                                          <span
                                            class="caption blue--text font-weight-medium"
                                            >Detalle de Deuda del Crédito Nº
                                            {{ item.numero }}</span
                                          >
                                        </v-col>
                                      </v-row>
                                      <v-row no-gutters>
                                        <v-col cols="3">
                                          <span class="caption">Cuota</span>
                                        </v-col>
                                        <v-col cols="2">
                                          <span class="caption"
                                            >Saldo Cta.</span
                                          >
                                        </v-col>
                                        <v-col cols="2">
                                          <span class="caption"
                                            >Punitorios</span
                                          >
                                        </v-col>
                                        <v-col cols="2">
                                          <span class="caption">Cargos</span>
                                        </v-col>
                                        <v-col cols="2">
                                          <span class="caption"
                                            >Saldo Total</span
                                          >
                                        </v-col>

                                        <v-col cols="1">
                                          <span class="caption"></span>
                                        </v-col>
                                      </v-row>
                                      <v-divider></v-divider>
                                      <template
                                        v-for="(
                                          subitem, subindex
                                        ) in item.detalle"
                                      >
                                        <v-row :key="subindex" no-gutters>
                                          <v-col cols="3">
                                            <div
                                              v-if="subitem.vencido"
                                              class="caption red--text"
                                            >
                                              Nº {{ subitem.numero }}, Vto.
                                              {{
                                                subitem.vencimiento
                                                  | dateParse()
                                                  | dateFormat('DD-MM-YY')
                                              }}
                                            </div>
                                            <div v-else class="caption">
                                              Nº {{ subitem.numero }}, Vto.
                                              {{
                                                subitem.vencimiento
                                                  | dateParse()
                                                  | dateFormat('DD-MM-YY')
                                              }}
                                            </div>
                                          </v-col>
                                          <v-col cols="2">
                                            <div
                                              v-if="subitem.vencido"
                                              class="caption red--text"
                                            >
                                              {{
                                                subitem.importeCuota | currency
                                              }}
                                            </div>
                                            <div v-else class="caption">
                                              {{
                                                subitem.importeCuota | currency
                                              }}
                                            </div>
                                          </v-col>
                                          <v-col cols="2">
                                            <div
                                              v-if="subitem.vencido"
                                              class="caption red--text"
                                            >
                                              {{
                                                subitem.importePunitorios
                                                  | currency
                                              }}
                                            </div>
                                            <div v-else class="caption">
                                              {{
                                                subitem.importePunitorios
                                                  | currency
                                              }}
                                            </div>
                                          </v-col>
                                          <v-col cols="2">
                                            <div
                                              v-if="subitem.vencido"
                                              class="caption red--text"
                                            >
                                              {{
                                                subitem.importeCargos | currency
                                              }}
                                            </div>
                                            <div v-else class="caption">
                                              {{
                                                subitem.importeCargos | currency
                                              }}
                                            </div>
                                          </v-col>
                                          <v-col cols="2">
                                            <div
                                              v-if="subitem.vencido"
                                              class="caption red--text"
                                            >
                                              {{
                                                subitem.importeTotal | currency
                                              }}
                                            </div>
                                            <div v-else class="caption">
                                              {{
                                                subitem.importeTotal | currency
                                              }}
                                            </div>
                                          </v-col>
                                          <v-col cols="1">
                                            <div class="caption">
                                              <v-icon
                                                v-if="
                                                  cuotaSeleccionada &&
                                                  cuotaSeleccionada.id ==
                                                    subitem.id
                                                "
                                                color="grey"
                                                @click="
                                                  cuotaSeleccionada = null
                                                "
                                                >remove</v-icon
                                              >
                                              <v-icon
                                                small
                                                v-else
                                                color="grey"
                                                @click="
                                                  elegirCuotaCredito(
                                                    item.id,
                                                    subitem
                                                  )
                                                "
                                                >touch_app</v-icon
                                              >
                                            </div>
                                          </v-col>
                                        </v-row>
                                      </template>
                                    </v-card-text>
                                  </v-card>
                                </v-container>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-row>
                      </template>
                    </v-container>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-container>

          <v-row>
            <v-col cols="12">
              <v-card v-if="selectedPersona">
                <v-card-title>
                  <span class="title">Cargos a Aplicar</span>
                  <v-spacer></v-spacer>
                  <span v-if="cuotaSeleccionada"
                    ><p>
                      Asociados a la Cuota {{ cuotaSeleccionada.cuota }} del
                      crédito {{ creditoSeleccionadoNumero }}
                    </p></span
                  >
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col cols="6">
                      <v-autocomplete
                        v-model="cargoAAgregarId"
                        :items="cargos"
                        item-text="descripcion"
                        item-value="id"
                        label="Cargo:"
                        placeholder="Seleccione un cargo a Agregar"
                      >
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field
                        label="Importe"
                        v-model="importeCargoAAgregar"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="1">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            text
                            icon
                            color="green"
                            v-on="on"
                            @click="agregarCargo"
                          >
                            <v-icon>add</v-icon>
                            <!-- <v-icon v-else>favorite_border</v-icon> -->
                          </v-btn>
                        </template>
                        Agregar un Cargo
                      </v-tooltip>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="9" class="font-weight-bold">Detalle</v-col>
                    <v-col cols="2" class="text-right font-weight-bold"
                      >Importe</v-col
                    >
                    <v-col cols="1" class="text-right font-weight-bold"></v-col>
                  </v-row>
                  <template v-for="(item, index) in listCargosAAplicar">
                    <v-row no-gutters :key="index">
                      <v-col cols="9">
                        <span v-if="item.item"
                          >Cargo: {{ item.cargoDescripcion }} - Cta. Nº
                          {{ item.item.numero }}, Vto.
                          {{
                            item.item.vencimiento
                              | dateParse()
                              | dateFormat('MM/YY')
                          }}
                          del Cred. Nº
                          <span class="font-italic font-weight-medium">
                            {{ item.numero }}
                          </span></span
                        >
                        <span v-else>Cargo: {{ item.cargoDescripcion }}</span>
                      </v-col>
                      <v-col cols="2"
                        ><div class="text-right">
                          {{ item.importeAAplicar | currency }}
                        </div></v-col
                      >
                      <v-col cols="1"
                        ><div class="text-right">
                          <v-icon color="red" small @click="quitarCargo(item)"
                            >clear</v-icon
                          >
                        </div></v-col
                      >
                    </v-row>
                  </template>
                  <v-divider></v-divider>
                  <v-row no-gutters>
                    <v-col cols="9" class="text-center font-weight-bold"
                      >TOTAL</v-col
                    >
                    <v-col cols="2" class="text-right font-weight-bold">{{
                      totalAAplicar | currency
                    }}</v-col>
                    <v-col cols="1" class="text-right font-weight-bold"></v-col>
                  </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>

          <span v-if="selectedPersona">
            <v-row>
              <v-col cols="6">
                <v-autocomplete
                  v-model="sucursalId"
                  :items="sucursales"
                  item-text="nombre"
                  item-value="id"
                  label="Sucursal:"
                  placeholder="Seleccione una"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="fecha"
                  label="Fecha del Comprobante"
                  type="date"
                  prepend-icon="event"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea
                  v-model="comentarios"
                  class="mx-2"
                  label="Comentarios Adicionales"
                  prepend-icon="comment"
                  clearable
                  auto-grow
                ></v-textarea>
              </v-col>
            </v-row>
          </span>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="blue darken-1" text @click.stop="hide(false)"
          >Cerrar</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click.stop="altaNotaDebito"
          >Confirmar</v-btn
        >
      </v-card-actions>
    </v-card>

    <template v-if="$store.state.debugModeOn">
      Debug Info:
      <p></p>
      {{ listCargosAAplicar }}
      CreditoSeleccionado: {{ creditoSeleccionadoId }}
      <p></p>
    </template>
  </v-container>
</template>

<script>
import Vue from 'vue';
import { http } from '@/axios';
import { format } from 'date-fns';

import { mapGetters, mapMutations } from 'vuex';

export default {
  data: () => ({
    saving: false,
    selectedPersona: null,
    seAsociaACredito: false,
    listDeudas: [],
    fecha: format(new Date(), 'YYYY-MM-DD'),
    showDetalleCredito: false,
    creditoSeleccionadoId: null,
    creditoSeleccionadoNumero: 0,
    listCargosAAplicar: [],
    sucursales: [],
    sucursalId: 0,
    cargos: [],
    cargoAAgregarId: 0,
    comentarios: '',
    cuotaSeleccionada: null,
    importeCargoAAgregar: 0,
  }),
  props: {
    persona: {
      type: Object,
      required: false,
      default: null,
    },
  },
  created() {
    this.loadSucursales();
    this.loadCargos();

    console.log('JSON.stringify( this.props.persona)');
    console.log(JSON.stringify(this.persona));

    if (this.persona) {
      this.setPersona(this.persona);
    }
  },
  computed: {
    ...mapGetters(['getActionFromLink', 'user']),
    listCreditosActivos: function () {
      if (!this.listDeudas || this.listDeudas.length == 0) return [];
      let lista = this.listDeudas.filter(
        (i) => i.tipo == 'Credito' || i.tipo == 'Acuerdo'
      );

      return lista;
    },

    totalAAplicar: function () {
      if (!this.listCargosAAplicar || this.listCargosAAplicar.length == 0)
        return 0;

      var total = 0;
      for (let index = 0; index < this.listCargosAAplicar.length; index++) {
        total =
          total + parseFloat(this.listCargosAAplicar[index].importeAAplicar);
      }
      return total;
    },
  },
  watch: {
    seAsociaACredito: function () {
      this.listCargosAAplicar = [];
      this.importeCargoAAgregar = 0;
    },
  },
  methods: {
    ...mapMutations([
      'setActiveTask',
      'setActiveSubTask',
      'hideActiveTask',
      'hideActiveSubTask',
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
    ]),
    hide(cerrarRelacionados) {
      //esto lo hago para que no se buguee cuando lo abro como subtask o task
      if (this.isSubTask) this.hideActiveSubTask();
      else this.hideActiveTask(cerrarRelacionados);
    },
    limpiar: function () {
      this.selectedPersona = null;
      this.creditoSeleccionadoId = null;
      this.creditoSeleccionadoNumero = 0;
      this.cuotaSeleccionada = null;
      this.listCargosAAplicar = [];
    },
    setPersona(persona) {
      this.selectedPersona = persona;
      this.personaId = persona.personaId;
      this.loadDeudas();
    },
    async loadDeudas() {
      this.listDeudas = [];
      this.loadingDeudas = true;
      try {
        var result = await http.get(
          'personas/listdeudasporcobrardetallada' +
            '?empresaId=0' +
            '&id=' +
            this.personaId +
            '&fechaCaja=' +
            format(new Date(), 'YYYY-MM-DD')
        );

        this.listDeudas = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loadingDeudas = false;
    },
    isExpandedDetalleCredito: function (item) {
      if (
        !item ||
        !this.creditoSeleccionadoId ||
        !this.showDetalleCredito ||
        !this.seAsociaACredito
      )
        return false;

      if (item.id == this.creditoSeleccionadoId) return true;
      else return false;
    },
    elegirCuotaCredito(creditoId, item) {
      // agrego hasta la cuota seleccionada mas todas las anteriores
      this.cuotaSeleccionada = this.listCreditosActivos
        .find((d) => d.id == creditoId)
        .detalle.find((i) => i.cuota == item.cuota);

      Vue.$log.debug(this.cuotaSeleccionada);

      var credito = this.listCreditosActivos.find((d) => d.id == creditoId);

      /* for (let index = 0; index < listaAAgregar.length; index++) {
            const el = listaAAgregar[index];
            
            // veo que ya no esté incluido
            if(this.listDeudasABonificar.find(i=> i.cuotaId == el.id ) != null ) continue;
            
            this.addCuota('Credito', creditoId, credito.numero, el, el.importeCuota, el.importePunitorios, el.importeCargos,
                         el.importeCapital, el.importeInteres, el.importeCargo1, el.importeCargo2, el.importeCargo3, el.importeCargo4, el.importeCargo5);
        } */
    },
    agregarCargo() {
      if (!this.validarAgregarCargo()) return;

      if (this.cuotaSeleccionada) {
        var credito = this.listCreditosActivos.find(
          (d) => d.id == this.creditoSeleccionadoId
        );
      }

      var cargo = this.cargos.find((c) => c.id == this.cargoAAgregarId);
      this.addCargo(
        credito ? credito.id : null,
        credito ? credito.numero : null,
        this.cuotaSeleccionada ? this.cuotaSeleccionada : null,
        this.importeCargoAAgregar,
        cargo.descripcion,
        cargo.id
      );

      this.cargoAAgregarId = 0;
      this.importeCargoAAgregar = 0;
    },
    addCargo(
      /*tipo,*/ creditoId,
      creditoNumero,
      cuota,
      importeAAplicar,
      cargoDescripcion,
      cargoId
    ) {
      var toAdd = {};
      //toAdd.tipo = 'Credito';
      if (cuota) {
        toAdd.id = creditoId;
        toAdd.numero = creditoNumero;
        toAdd.cuotaId = cuota.id;
        toAdd.cuota = cuota.cuota;
        toAdd.item = cuota;
      }

      toAdd.importeAAplicar = importeAAplicar;
      toAdd.cargoDescripcion = cargoDescripcion;
      toAdd.cargoId = cargoId;

      this.listCargosAAplicar.push(toAdd);
    },
    quitarCargo(item) {
      Vue.$log.debug(item);
      // si el concepto es de una cuota de crédito, quito de la seleccinada para adelante
      //var listaAQuitar = this.listCargosAAplicar.filter(d=> d.id == creditoId && d.item.cuota >= item.cuota);
      var indexToRemove = this.listCargosAAplicar
        .map((x) => x.cargoId)
        .indexOf(item.cargoId);

      this.listCargosAAplicar.splice(indexToRemove, 1);
    },
    async altaNotaDebito() {
      if (!this.validarAlta()) return;

      var params = {};
      params.creditoId = this.creditoSeleccionadoId;
      params.personaId = this.personaId;
      params.sucursalId = this.sucursalId;
      params.fecha = this.fecha;
      params.esFiscal = false;
      params.detalle = this.listCargosAAplicar;
      params.comentarios = this.comentarios;
      params.importeTotal = this.totalAAplicar;

      try {
        this.saving = true;
        await http.post(
          'comprobantes/altanotadebito',
          JSON.stringify({ parametros: params })
        );

        this.alertSuccess('Se han generado los Cargos.');
        this.limpiar();
      } catch (error) {
        // Error
        this.alertError(error);
      }

      this.saving = false;
    },
    validarAgregarCargo() {
      if (this.listCargosAAplicar.length >= 9) {
        this.alertWarning(
          'No se pueden agregar más de 9 cargos en un comprobante.'
        );
        return;
      }

      if (!this.cargoAAgregarId) {
        this.alertWarning('Debe elegir un tipo de cargo para agregar.');
        return;
      }

      var cargo = this.listCargosAAplicar.find(
        (c) => c.cargoId == this.cargoAAgregarId
      );
      Vue.$log.debug(this.cargoAAgregarId);
      Vue.$log.debug(cargo);
      if (cargo) {
        this.alertWarning('No puede agregar dos cargos del mismo tipo.');
        return;
      }

      if (!this.importeCargoAAgregar || isNaN(this.importeCargoAAgregar)) {
        this.alertWarning(
          'El importe del cargo a agregar es inválido. Verifique.'
        );
        return;
      }

      if (this.seAsociaACredito) {
        if (!this.creditoSeleccionadoId || !this.cuotaSeleccionada) {
          this.alertWarning(
            'Debe elegir la cuota para asociar el cargo o desmarcar la opción Se asocia a un Crédito.'
          );
          return;
        }

        if (this.listCargosAAplicar.length > 0) {
          this.alertWarning(
            'No se puede agregar más de 1 cargo asociado a un crédito.'
          );
          return;
        }
      }

      return true;
    },
    validarAlta() {
      if (!this.personaId) {
        this.alertWarning('Debe elegir una persona.');
        return false;
      }

      if (this.seAsociaACredito) {
        if (!this.creditoSeleccionadoId) {
          this.alertWarning('Debe elegir un crédito.');
          return false;
        }

        if (this.listCargosAAplicar.length > 1) {
          this.alertWarning(
            'No se puede generar un comprobante con más de 1 cargo asociado a un crédito.'
          );
          return;
        }
      }

      if (!this.sucursalId) {
        this.alertWarning('Debe elegir una sucursal.');
        return false;
      }

      if (!this.fecha) {
        this.alertWarning('Debe ingresar la fecha del comprobante.');
        return false;
      }

      if (!this.listCargosAAplicar || this.listCargosAAplicar.length == 0) {
        this.alertWarning('Debe ingresar algún cargo.');
        return false;
      }

      return true;
    },
    async loadSucursales() {
      this.loading = true;
      try {
        var result = await http.get(
          'sucursales/list/porusuario?usuarioId=' + this.user.id
        );

        this.sucursales = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadCargos() {
      this.loading = true;
      try {
        var result = await http.get('cargos');

        this.cargos = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
  },
};
</script>
